import React from "react";
import { Button, Space, Table, Tag, Input, Spin, Tab  } from 'antd';
import { LoadingOutlined, SearchOutlined} from '@ant-design/icons';
import { useState } from "react";
import { useEffect } from "react";

function TenantConstructionStatus() {

    //setea lista en la tabla
const [dataSource, setDataSource] = useState([
    {
    id: "test",
    Name: "test",
    LOIStatus: "test",
    entity: "test,"
    },
    {
    id: "tast",
    Name: "tast",
    LOIStatus: "tast",
    entity: "tast,"
    },
    {
        id: "tist",
        Name: "tist",
        LOIStatus: "tost",
        entity: "tist,"
        },

])

const [loading, setLoading] = useState(true);
const [testingg, setTesttingg] = useState(true);


//make a reques on the table
useEffect(() => {
    setLoading(true);
   
    fetch('https://app.asana.com/api/1.0/projects/1206645845765347/tasks?opt_fields=name,assignee.name,completed,custom_fields,gid,parent,due_on  ',
    {
        method: 'GET',
        headers: {
            'Authorization': `Bearer 2/1206524890494959/1206900667183984:cb7dbca327758d58acea87a8a0d3590d`
        }
    }
)
    .then(response => {
      if (!response.ok) {
        throw new Error('Error en la solicitud');
      }
      return response.json();
    })
    .then(data => {
      // Aquí puedes manipular los datos recibidos en formato JSON
      setDataSource([]);
      console.log(data);
      const acaseras = data.data;
      console.log(data.data[0]);
              
     const newMap = acaseras.map(DataHere => {
        //sete las execution
        const lastExecutionData = DataHere.custom_fields[2].display_value;
        const lastExecutionDataFormated = new Date(lastExecutionData);
        const lastExecutionDataSimple =  lastExecutionDataFormated.toLocaleString('es-PY', { timeZone: 'UTC' }).toString().split(",");
       //sete delivery
       const deliveryExecutionData = DataHere.custom_fields[4].display_value;
       const deliveryDataFormated = new Date(deliveryExecutionData);
       const deliveryDataSimple =  deliveryDataFormated.toLocaleString('es-PY', { timeZone: 'UTC' }).toString().split(",");

        //sete Rent Commencement
        const RentExecutionData = DataHere.custom_fields[3].display_value;
       const RentDataFormated = new Date(RentExecutionData);
       const RentDataSimple =  RentDataFormated.toLocaleString('es-PY', { timeZone: 'UTC' }).toString().split(",");

       
        let tenantNameParse = DataHere.name === null ? "---" : DataHere.name;
        let staeCompleted = DataHere.completed === true ? "Completed" : "No Completed";
        const entityParse = DataHere.custom_fields[0].display_value === null ? "---" : DataHere.custom_fields[0].display_value;
       
            try {
              
                 
        setDataSource(prev=>{
            //const urlAncla = `href="https://app.asana.com/0/1202771100962765/${DataHere.gid}/f"` ;
            return [...prev, {
                key:DataHere.gid, 
                Id: DataHere.gid, 
                PropertyEntity: entityParse, 
                tenantName: tenantNameParse, 
                lastExecution: lastExecutionDataSimple[0],
                delivery:deliveryDataSimple[0],
                rentCommencement: RentDataSimple[0],
                 completed: staeCompleted    
                } ]} )
            
               
            } catch (error) {
                console.log(error)
            }
            
          });

setLoading(false);
})
    .catch(error => {
      console.error('Hubo un problema con la solicitud:', error);
    });
  
    console.log("hola por aca")

}, [testingg]);

const columns = [
    
    {
        title: 'Property Entity',
        dataIndex: 'PropertyEntity',
        key: 'Property Entity',
        
    },
    {
        title: 'Tenant Name',
        dataIndex: 'tenantName',
        key: 'tenantName',
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
            
            return (
            <>
              <Input 
              autoFocus 
              placeholder="Type text here"
              value={selectedKeys[0]}
              onChange={(e)=> {
                  
                  setSelectedKeys(e.target.value ? [e.target.value]:[])
              }}
              onPressEnter={()=> {
                  confirm()
              }}
              onBlur={()=> {
                  confirm()
              }}
              >
              </Input>
              <Button 
              type="primary"
              onClick={() => {
                  confirm();
              }} 
              >Search
              </Button>
              <Button onClick={() => {
                try {
                    clearFilters();
                    confirm();
                } catch (error) {
                    
                }
                 
              }} 
              danger>
                  Reset
              </Button>
            </>
            );
        },
        filterIcon:() => {
            return <SearchOutlined/>
        },
        onFilter: (value, record) => {
            try {
                return record.tenantName.toLowerCase().includes(value.toLowerCase())
            } catch (error) {
                
            }
           
            
        },     
    },
    {
        title: 'Last Execution',
        dataIndex: 'lastExecution',
        width: 200,
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
            
            return (
            <>
              <Input 
              autoFocus 
              placeholder="Type text here"
              value={selectedKeys[0]}
              onChange={(e)=> {
                  
                  setSelectedKeys(e.target.value ? [e.target.value]:[])
              }}
              onPressEnter={()=> {
                  confirm()
              }}
              onBlur={()=> {
                  confirm()
              }}
              >
              </Input>
              <Button 
              type="primary"
              onClick={() => {
                  confirm();
              }} 
              >Search
              </Button>
              <Button onClick={() => {
                try {
                    clearFilters();
                    confirm();
                } catch (error) {
                    
                }
                 
              }} 
              danger>
                  Reset
              </Button>
            </>
            );
        },
        filterIcon:() => {
            return <SearchOutlined/>
        },
        onFilter: (value, record) => {
            try {
                return record.task.toLowerCase().includes(value.toLowerCase())
            } catch (error) {
                
            }
           
            
        },        
    },
    {
        title: 'Delivery (Projected)',
        dataIndex: 'delivery',
        key: 'delivery',
        width: 150,
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
            
            return (
            <>
              <Input 
              autoFocus 
              placeholder="Type text here"
              value={selectedKeys[0]}
              onChange={(e)=> {
                  
                  setSelectedKeys(e.target.value ? [e.target.value]:[])
              }}
              onPressEnter={()=> {
                  confirm()
              }}
              onBlur={()=> {
                  confirm()
              }}
              >
              </Input>
              <Button 
              type="primary"
              onClick={() => {
                  confirm();
              }} 
              >Search
              </Button>
              <Button onClick={() => {
                try {
                    clearFilters();
                    confirm();
                } catch (error) {
                    
                }
                 
              }} 
              danger>
                  Reset
              </Button>
            </>
            );
        },
        filterIcon:() => {
            return <SearchOutlined/>
        },
        onFilter: (value, record) => {
            try {
                return record.delivered.toLowerCase().includes(value.toLowerCase())
            } catch (error) {
                
            }
           
            
        },
        
},
    {
        title: 'Rent Commencement',
        dataIndex: 'rentCommencement',
        key: 'rentCommencement',
        width: 130,
    },
    
{
    title: 'Is Completed',
    dataIndex: 'completed',
    key: 'completed',
    width: 150,
   filters: [
        {
            text:"Completed",
            value:"Completed",
        },
        {
            text:"No Completed",
            value:"No Completed",
        },
        
    ],
    onFilter: (value, record) => {
        try {
           return record.completed.indexOf(value) === 0
        } catch (error) { 
    }
    
}},

{
    title: 'Link',
    dataIndex: 'Id',
    key: 'Id',
    width: 100,
    render: (text) => <a href={'https://app.asana.com/0/1202771100962765/' + text + '/f'} target="_blank">View task</a>,
},

]








const onChange = (pagination, filters) => {
    console.log('params', pagination, filters);
  };
    

    return (
        <>
        <h1>Tenant Construction Status</h1>
        <Spin 
        tip="Loading..." 
        spinning={loading} 
        size="large"
        className="splinLoad"
        
        >
        {loading ? '' : <Table   columns={columns} dataSource={dataSource} onChange={onChange} /> }
        </Spin>
       
        </>
    )
    
}


export { TenantConstructionStatus }